module.exports = __webpack_public_path__ + "assets/img/DS.d35c9a63.jpg";